module.exports = {
	"id": "TG",
	"name": "Togo",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.06777,
			"12": null,
			"13": 0.00251,
			"14": 0.02008,
			"15": null,
			"16": 0.01255,
			"17": null,
			"18": 0.01004,
			"19": 0.01506,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.00502,
			"24": null,
			"25": 0.02259,
			"26": 0.01004,
			"27": 0.01506,
			"28": 0.01757,
			"29": 0.05522,
			"30": 0.07028,
			"31": 0.0251,
			"32": 0.03012,
			"33": 0.04016,
			"34": 0.00502,
			"35": 0.00502,
			"36": 0.02008,
			"37": 0.01004,
			"38": 0.00502,
			"39": 0.02008,
			"40": 0.07781,
			"41": 0.01255,
			"42": 0.01255,
			"43": 0.37399,
			"44": 0.02008,
			"45": 0.34638,
			"46": 0.04518,
			"47": 0.0753,
			"48": 0.04016,
			"49": 0.64005,
			"50": 0.09036,
			"51": 0.56726,
			"52": 0.32379,
			"53": 3.765,
			"54": 1.0542,
			"55": 0.01506,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": 0.00753,
			"3": 0.12801,
			"4": null,
			"5": null,
			"6": 0.00251,
			"7": 0.00753,
			"8": 0.00753,
			"9": 0.00753,
			"10": 0.00502,
			"11": 0.02259,
			"12": 0.01757,
			"13": 0.01004,
			"14": 0.00502,
			"15": 0.00753,
			"16": 0.03012,
			"17": 0.01255,
			"18": 0.01004,
			"19": 0.02008,
			"20": 0.04769,
			"21": 0.02008,
			"22": 0.06024,
			"23": 0.05271,
			"24": 0.0502,
			"25": 0.00753,
			"26": 0.01757,
			"27": 0.07028,
			"28": 0.05522,
			"29": 0.12801,
			"30": 0.16064,
			"31": 0.2259,
			"32": 0.08785,
			"33": 0.06526,
			"34": 0.11044,
			"35": 0.12801,
			"36": 0.05773,
			"37": 0.1506,
			"38": 0.15311,
			"39": 0.06024,
			"40": 0.31626,
			"41": 0.14307,
			"42": 0.14056,
			"43": 0.83081,
			"44": 0.17821,
			"45": 0.33383,
			"46": 0.2259,
			"47": 1.09687,
			"48": 0.90109,
			"49": 5.90352,
			"50": 0.2259,
			"51": 0.02008,
			"52": null,
			"3.5": 0.00502,
			"3.6": 0.0502
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.01255,
			"15": 0.00251,
			"16": 0.00502,
			"17": null,
			"18": 0.01004,
			"19": 0.03514,
			"20": null,
			"21": null,
			"22": 0.00502,
			"23": null,
			"24": 0.00251,
			"25": null,
			"26": 0.00251,
			"27": null,
			"28": null,
			"29": 0.02761,
			"30": 0.00251,
			"31": null,
			"32": null,
			"33": 0.01255,
			"34": 0.00502,
			"35": 0.03012,
			"36": 0.04016,
			"37": 0.13052,
			"38": 0.02259,
			"39": 0.1255,
			"40": 0.38905,
			"41": 0.06777,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": 0.01757,
			"11.5": null,
			"11.6": null,
			"12.1": 0.01004
		},
		"safari": {
			"0": null,
			"4": 0.01255,
			"5": null,
			"6": null,
			"7": 0.01255,
			"8": 0.05271,
			"9": 0.01757,
			"10": 0.18825,
			"3.1": null,
			"3.2": null,
			"5.1": 0.00251,
			"6.1": null,
			"7.1": null,
			"9.1": 0.08785
		},
		"ios_saf": {
			"8": 0,
			"10": 0.522254437968,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0140741527893,
			"8.1-8.4": 0.0260014009159,
			"9.0-9.2": 0.0124043380516,
			"9.3": 0.189245670275
		},
		"android": {
			"3": 0,
			"4": 0.148890361757,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0186112952196,
			"4.1": 0.53706880491,
			"4.2-4.3": 1.34267201227,
			"4.4": 3.07883998062,
			"4.4.3-4.4.4": 3.10542754522
		},
		"ie": {
			"6": 0.0230776278119,
			"7": 0.0230776278119,
			"8": 0.351933824131,
			"9": 0.0692328834356,
			"10": 0.190390429448,
			"11": 0.741368793456,
			"5.5": null
		},
		"op_mob": {
			"0": 2.68647363678,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0746242676883
		},
		"edge": {
			"12": 0.0753,
			"13": 0.1004,
			"14": 0.07781
		},
		"ie_mob": {
			"10": 0.245165633803,
			"11": 0.998174366197
		},
		"bb": {
			"7": 0.048685,
			"10": null
		},
		"samsung": {
			"0": 1.01864
		},
		"and_uc": {
			"0": 7.19789
		},
		"op_mini": {
			"0": 36.1943920955
		},
		"and_chr": {
			"0": 18.00356
		},
		"and_ff": {
			"0": 0.05243
		}
	},
	"total": 98.8243961861
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TG.json
 ** module id = 657
 ** module chunks = 0
 **/